import { Type } from "@sinclair/typebox";
const id = Type.String({ minLength: 1, maxLength: 120 });
const body = Type.String({ maxLength: 12000 });
const options = { additionalProperties: false };
// The union branches deliberately allow additional properties: Fastify's AJV
// removes them while trying each anyOf branch. Shape-specific extra fields are
// rejected by assertQuoteDocumentLayout after discriminator validation.
export const quoteDocumentSectionSchema = Type.Union([
    Type.Object({ id, kind: Type.Literal("introduction"), body }),
    Type.Object({ id, kind: Type.Literal("roof_image") }),
    Type.Object({ id, kind: Type.Literal("works") }),
    Type.Object({ id, kind: Type.Literal("conditions") }),
    Type.Object({
        id,
        kind: Type.Literal("text"),
        title: Type.String({ maxLength: 200 }),
        body,
        sourceTextId: Type.Optional(id)
    }),
    Type.Object({
        id,
        kind: Type.Literal("image"),
        dataUrl: Type.String({
            maxLength: 2800000,
            pattern: "^data:image/(png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$"
        }),
        caption: Type.String({ maxLength: 2000 }),
        layout: Type.Union([Type.Literal("full"), Type.Literal("half")])
    })
]);
export const quoteDocumentLayoutSchema = Type.Object({ sections: Type.Array(quoteDocumentSectionSchema, { minItems: 2, maxItems: 40 }) }, options);
export const quoteDocumentLibrarySchema = Type.Object({
    texts: Type.Array(Type.Object({ id, title: Type.String({ minLength: 1, maxLength: 200 }), body }, options), { maxItems: 100 }),
    presets: Type.Array(Type.Object({
        id,
        name: Type.String({ minLength: 1, maxLength: 200 }),
        textIds: Type.Array(id, { maxItems: 40, uniqueItems: true })
    }, options), { maxItems: 50 })
}, options);
export function assertQuoteDocumentLayout(layout) {
    for (const section of layout.sections) {
        const permitted = new Set([
            "id",
            "kind",
            ...(section.kind === "introduction"
                ? ["body"]
                : section.kind === "text"
                    ? ["title", "body", "sourceTextId"]
                    : section.kind === "image"
                        ? ["dataUrl", "caption", "layout"]
                        : [])
        ]);
        if (Object.keys(section).some((key) => !permitted.has(key)))
            throw new Error("Una sezione contiene campi non compatibili con il suo tipo.");
    }
    const ids = layout.sections.map((section) => section.id);
    if (new Set(ids).size !== ids.length)
        throw new Error("Le sezioni devono avere identificativi distinti.");
    for (const kind of ["introduction", "roof_image", "works", "conditions"]) {
        const count = layout.sections.filter((section) => section.kind === kind).length;
        if (count > 1 || ((kind === "works" || kind === "conditions") && count !== 1))
            throw new Error("Lavorazioni e condizioni sono obbligatorie; le sezioni principali non possono essere duplicate.");
    }
    const images = layout.sections.filter((section) => section.kind === "image");
    if (images.length > 6 ||
        images.reduce((total, image) => total + image.dataUrl.length, 0) > 11000000)
        throw new Error("Sono consentite fino a sei immagini, per un totale di 8 MB.");
}
//# sourceMappingURL=quote-document.js.map